import { render, staticRenderFns } from "./EventDetail.vue?vue&type=template&id=31ea3967&scoped=true"
import script from "./EventDetail.vue?vue&type=script&lang=ts"
export * from "./EventDetail.vue?vue&type=script&lang=ts"
import style0 from "./EventDetail.vue?vue&type=style&index=0&id=31ea3967&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea3967",
  null
  
)

export default component.exports